import React, {useEffect, useState} from 'react';
import WeatherCard from './WeatherCard'
import './WeatherList.css';

const WeatherList = (props) => {

	const [currentWeather, setCurrentWeather] = useState({});
	const [fiveDayForcast, setFiveDayForcast] = useState([]);
	const [dayNames, setDayNames] = useState([])

	async function getWeatherData() {
		// const cityId = '2158177';
		const apiKey = '817aa5717dafc394955e8b4b98539abc';
	try {
		// const response = await fetch(`https://api.openweathermap.org/data/2.5/weather?id=${cityId}&units=metric&appid=${apiKey}`);
		const response = await fetch(`https://api.openweathermap.org/data/2.5/onecall?lat=-37.81&lon=144.96&appid=${apiKey}`)
		const data = await response.json();
		await setCurrentWeather(data.current)
		await setFiveDayForcast(data.daily.slice(0,5));
	} catch(error) {
		console.log(error)
		}
	}

	function getDayNames() {
		let days = ["Today", ];
		let date = new Date()
		let weekday = new Array(7);
			weekday[0] = "Sunday";
			weekday[1] = "Monday";
			weekday[2] = "Tuesday";
			weekday[3] = "Wednesday";
			weekday[4] = "Thursday";
			weekday[5] = "Friday";
			weekday[6] = "Saturday";

			for (let i=1; i<5; i++) {
				if (date.getDay() + i > 6) {
					days.push(weekday[date.getDay() + i - 7])
				} else {
					days.push(weekday[date.getDay() + i])
				}
				
			}
			return setDayNames(days)
		}


	useEffect(() => {
		getWeatherData();
		getDayNames();
		// getFiveDayForcast();
	}, [])


	return (	
		<div id='weather' className='weather-list-container' onClick={props.toggleWeather}>
			<div  className='widget-labels weather-button-container'>
				<h3>Melbourne</h3>
				<div className='weather-button-content'>
					<div className='current-weather-temp'>
						{Math.round(currentWeather.temp - 273)}°C
					</div>
					<div className='current-weather-icon'>
						<img src={`https://openweathermap.org/img/wn/${(Object.keys(currentWeather).length === 0) ? '' : currentWeather.weather[0].icon}.png`} alt='rain' />
					</div>
				</div>
			 </div>
			<div className='weather-container widget'>
				<div className='weather-location'>
					Melbourne
				</div>
				<hr />
				<div className='current-weather-container'>
					<div className='current-weather-content'>
						<div className='current-weather-description'>
							{(Object.keys(currentWeather).length === 0) ? '' : currentWeather.weather[0].description}
						</div>
						<div className='current-weather-temp'>
							{Math.round(currentWeather.temp - 273)}°C
						</div>
					</div>
					<div className='current-weather-icon'>
						<img src={`https://openweathermap.org/img/wn/${(Object.keys(currentWeather).length === 0) ? '' : currentWeather.weather[0].icon}.png`} alt='rain' />
					</div>
				</div>
				<div className='five-day-forcast-container'>
					{ fiveDayForcast.map((day, i) => {
						return <WeatherCard 
							maxTemp={Math.round(day.temp.max - 273)}
							minTemp={Math.round(day.temp.min - 273)}
							icon={day.weather[0].icon}
							day={dayNames[i]}
							key={i}

						/>
							})
					}
				</div>
			</div>
		</div>
	)
}

export default WeatherList;